import {FC, PropsWithChildren, memo} from 'react'

export const genericMemo: <T>(
  Component: T,
  propsAreEqual?: (prevProps: PropsWithChildren<T>, nextProps: PropsWithChildren<T>) => boolean,
) => Pick<FC, 'displayName'> & T = memo
